import Text from 'components/base/Text';

const RevokeTokenTooltipNoAdmin = () => {
  return (
    <div>
      <Text size='large' pt='16px'>
        Rveoke Token
      </Text>
      <Text color='gray' size='large' pt='8px' pb='16px'>
        You need admin permissions to <br />
        revoke tokens
      </Text>
    </div>
  );
};

export default RevokeTokenTooltipNoAdmin;
